export default "__VITE_ASSET__GCyQPT1q__"